export default {
  strict: true,
  state: {
    menuitems: [
      { id: '0', icon: 'content_copy', text: 'Submitted applications', route: 'submittedapplications', number: null },
      { id: '1', icon: 'content_copy', text: 'Pending applications', route: 'pendingapplications', number: null },
      { id: '3', icon: 'content_copy', text: 'Approved applications', route: 'approvedapplications', number: null },
      { id: '4', icon: 'content_copy', text: 'Rejected applications', route: 'rejectedapplications', number: null },
      { id: '5', icon: 'content_copy', text: 'Cancelled applications', route: 'cancelledapplications', number: null }
    ]
  },
  mutations: {
    setMenuitems (state, update) {
      state.menuitems[update.id].number = update.numbervalue
    }
  },
  getters: {
    getMenuitems (state, getters) {
      return state.menuitems
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menuitems.js